import { ReactElement } from 'react';

import { ConfidentialResourceAccessRequest } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { createInterpolatedTranslationKey, dateTimeMinuteFormatter, Translate } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../translations';

type DecisionDateCellProps = {
   request: ConfidentialResourceAccessRequest;
};

export const DecisionDateCell = (props: DecisionDateCellProps): ReactElement | null => {
   const { request } = props;

   if (!request.decisionDate) {
      return null;
   }

   const formattedDate = dateTimeMinuteFormatter(request.decisionDate);

   if (request.requestStatus === 'REJECTED') {
      return (
         <Translate>
            {createInterpolatedTranslationKey(systemActivityTranslationKeys.decisionDateRejected, {
               decisionDate: formattedDate,
            })}
         </Translate>
      );
   }

   return <>{formattedDate}</>;
};
